type Props = {
  highlighted: boolean
}

export function Bag(props: Props) {
  const { highlighted = false } = props

  return (
    <svg
      width="50"
      height="66"
      viewBox="0 0 50 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`bag ${highlighted ? 'highlighted' : ''}`}
    >
      <path
        d="M8.73047 18.4602H50.0003V65.2856H8.73047V18.4602Z"
        className="cover background"
      />
      <path
        d="M8.73047 18.4602H50.0003V65.2856H8.73047V18.4602Z"
        className="cover animation"
      />
      <path className="shadow" d="M0 18.4602H8.73016V65.2856H0V18.4602Z" />
      <path
        d="M11.7705 18.804V15.0159C11.7705 7.27514 17.241 1 23.9891 1C30.7373 1 36.2078 7.27514 36.2078 15.0159V18.804"
        stroke="#545454"
        strokeWidth="1.5"
      />
      <circle cx="16.8969" cy="22.5199" r="1.5873" className="shadow" />
      <circle cx="41.3344" cy="22.5199" r="1.5873" className="shadow" />
      <path
        d="M16.9951 22.5386V15.0159C16.9951 7.27514 22.4656 1 29.2137 1C35.9619 1 41.4324 7.27514 41.4324 15.0159V22.5386"
        stroke="#545454"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className="priceTag">
        <path
          d="M21.8574 30.4602C21.8574 28.0602 21.8574 21.4602 21.8574 18.4602"
          stroke="#CC3D3D"
        />
        <path
          d="M18.3574 34.07C18.3574 33.9418 18.4066 33.8186 18.4949 33.7256L21.4949 30.5677C21.692 30.3602 22.0228 30.3602 22.2199 30.5677L25.2199 33.7256C25.3082 33.8186 25.3574 33.9418 25.3574 34.07V44.4602C25.3574 44.7363 25.1336 44.9602 24.8574 44.9602H18.8574C18.5813 44.9602 18.3574 44.7363 18.3574 44.4602V34.07Z"
          fill="#CC3D3D"
          stroke="#CC3D3D"
        />
      </g>
    </svg>
  )
}
